module.exports = __webpack_public_path__ + "img/赵卫卫.d315de16.jpg";